import React from 'react'
import {
    FormControl,
    FormLabel,
    Textarea,
} from "@chakra-ui/react";

export const FormTextArea = ({ name, label, value, inputOnChange, isReadOnly = false, padding, isRequired, maxWidth }) => {
    return (
        <FormControl padding={padding} isRequired={isRequired}>
            <FormLabel
                fontSize="15px"
                textTransform="capitalize"
                fontWeight={600}
            >
                {label}
            </FormLabel>
            <Textarea
                placeholder={label}
                name={name}
                value={value}
                onChange={inputOnChange}
                readOnly={isReadOnly}
                maxWidth={maxWidth}
            />
        </FormControl>
    )
}
